import React, { useState } from 'react';
import { useFetchBetBuilderMatchBets } from '../../data/useFetchBetBuilderMatchBets';
import Loader from '../../common/Loader';
import Match from '../match/Match';
import { BetsExpandCollapseContext, useBetsExpandCollapseContext } from '../../common/BetsExpandCollapseContext';
import AggregataSelector from '../../common/AggregataSelector';
import { parseBetsData } from '../../data/parseBetsData';

function BetBuilderEvent(props) {
    const [betsExpandCollapseContext] = useBetsExpandCollapseContext();
    const data = props.data;
    const aggs = data.betsData.gruppiScommessa;
    const [aggId, setAggId] = useState(aggs[0].idAggregata);
    const agg = data.betsData.gruppoById[aggId];

    const markets = parseBetsData(data.match, data.aggregatesIds, aggId, data.rawBets, false).bets;
    
    const match = {
        ...data.match,
        ...data.betsData
    };
    
    return (
        <>
            <AggregataSelector betGroups={aggs} aggregata={aggId} changeBetGroup={(aggId) => setAggId(aggId)} />
            <BetsExpandCollapseContext.Provider value={betsExpandCollapseContext}>
                <Match {...match} bets={markets} aggregata={agg} />
            </BetsExpandCollapseContext.Provider>
        </>
    );
}

export default function BetBuilderEventFetcher(props) {
    const match = props.match;
    
    const [request] = useFetchBetBuilderMatchBets(match, true, false);
    
    if (request.isLoading || request.isError) {
        return (
            <>
                <Loader error={request.isError} />
            </>
        );
    }

    return <BetBuilderEvent data={request.data} />;
}
